export function getUacBaseUrl() {
  let host = window.location.hostname;
  if (/-local|localhost|^192|^127|^172/.test(host)) {
    return "/api/";
  } else if (/-dev/.test(host)) {
    return "http://ucenter2-api-dev.huolala.work";
  } else if (/-stg/.test(host)) {
    return "https://sg-ucenter2-api-stg.lalamove.com";
  } else if (/-pre/.test(host)) {
    return "https://sg-ucenter2-api-pre.lalamove.com";
  } else if(/in-ucenter2.lalamove.com/.test(host)) {
    return "https://in-ucenter2-api.lalamove.com";
  } else {
    return "https://sg-ucenter2-api.lalamove.com";
  }
}

export function isNumber(val) {
  const regPos = /^[0-9]+.?[0-9]*/; //判断是否是数字。

  if (regPos.test(val)) {
    return true;
  } else {
    return false;
  }
}
